"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
const useBrowser = content => {
  const [activeBanner, setActiveBanner] = (0, _react.useState)(true);
  const removeAlert = () => {
    setActiveBanner(!activeBanner);
  };
  const checkForSafari = () => {
    if (typeof navigator !== undefined) {
      if (navigator.vendor.match(/apple/i)) {
        return true;
      } else {
        return false;
      }
    }
  };
  const checkForIE = () => {
    if (typeof navigator !== undefined) {
      const userAgent = navigator.userAgent;

      // MSIE used to detect old browsers and Trident used to newer ones
      const is_ie = userAgent.indexOf("MSIE ") > -1 || userAgent.indexOf("Trident/") > -1;
      return is_ie;
    }
  };
  (0, _react.useEffect)(() => {
    const checkBrowser = () => {
      if (typeof window !== "undefined" && typeof document !== "undefined" && typeof navigator !== undefined) {
        // the !! will convert the response to a boolean. Without doing so, the following will return either an array or null.

        // Opera 8.0+
        const Opera = !!window.opera || navigator.userAgent.indexOf(" OPR/") >= 0;

        // Firefox 1.0+
        const Firefox = typeof InstallTrigger !== undefined;

        // Safari 3.0+ "[object HTMLElementConstructor]"
        const Safari = checkForSafari();

        // Internet Explorer 6-11
        const IE = !!document.documentMode || checkForIE();

        // Edge 20+
        const Edge = !IE && !!window.StyleMedia;

        // Chrome 1 - 79
        const Chrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);

        // Edge (based on chromium) detection
        const EdgeChromium = Chrome && navigator.userAgent.indexOf("Edg") != -1;
        const output = {
          firefox: Firefox,
          safari: Safari,
          ie: IE,
          edge: Edge,
          chrome: Chrome,
          EdgeChromium: EdgeChromium
        };
        let currentBrowser;
        for (let i in output) {
          if (output[i] === true) {
            currentBrowser = i;
          }
        }
        if (currentBrowser === content.browser.toLowerCase()) {
          setActiveBanner(true);
        } else {
          setActiveBanner(false);
        }
      }
    };
    checkBrowser();
  }, [content, removeAlert, checkForIE, checkForSafari]);
  return {
    activeBanner,
    removeAlert,
    checkForIE,
    checkForSafari,
    setActiveBanner
  };
};
var _default = useBrowser;
exports.default = _default;